import "./productDetailsComponent.css";
import { useEffect, useState } from "react";
import { getProductCompleteInfo } from "../../services/products"

interface Products {
  id: number;
  collibri_id: number;
  collibri_status: number;
  name: string;
  description: string;
  food_region: string;
  pax: number;
  product_type: string;
  category: number;
  is_enabled: boolean;
  combo_flexible: boolean;
  picture: string;
  min_additional: number;
  max_additional: number;
  steak_point: string | null;
  created_by: number;
  created_at: string;
  modified_by: number | null;
  modified_at: string | null;
  additionais: {
    id: number;
    collibri_id: number;
    name: string;
    description: string;
    price: number;
  }[];
  complements: {
    id: number;
    collibri_id: number;
    name: string;
    description: string;
    price: number;
  } [];
}
export default function ProductDetailsComponent({ id }: any) {
  const [products, setProducts] = useState<Products | any>({});
  const [disabled, setDisabled] = useState<boolean>(true);
  useEffect(() => {
    getProductCompleteInfo(id)
      .then((response) => {
        console.log(response.data, 'aqui 2');
        setProducts(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <div
        className={
          disabled ? "product_details_box" : "product_details_box disabled"
        }
      >
        <div className="product_details_img">
          <img src={products.picture} alt="" />
        </div>
        <div className="product_details_info_box">
          <div className="product_details_primary_info_box">
            <div>
              <div className="product_details_name_box">
                <p>{products.name}</p>
              </div>
              <div className="product_details_description_box">
                <p>{products.description}</p>
              </div>
            </div>
            <div className="product_details_price_box">
              <div>{products.price}</div>
              <div>{products.price_tag}</div>
            </div>
          </div>
          <div className="divider"></div>
          <div className="product_details_category_box">
            <p className="product_details_name_box">Categoria:</p>
            <p>{products.category}</p>
          </div>
          <div className="product_details_code_box">
            <p className="product_details_name_box">Código:</p>
            <p>{products.code}</p>
          </div>
        </div>
      </div>
    </>
  );
}
